import type { CSSProperties, JSX } from 'react';
import somethingWentWrongSvg from '../assets/images/error/error-sww.svg';

/**
 * Decorative "something went wrong" illustration. Loaded via <img> (not
 * inlined as JSX) since its colors are literal hex, not `currentColor`/CSS
 * custom properties — nothing here needs the host page's styles to resolve.
 */
export function SomethingWentWrongIllustration({
  className,
  style,
}: {
  readonly className?: string;
  readonly style?: CSSProperties;
}): JSX.Element {
  return <img alt="" aria-hidden="true" className={className} src={somethingWentWrongSvg} style={style} />;
}
